export const GOVERNANCE_ADMIN_PATH = {
  ROOT: '/admin/governance-admin',
  NEWS: '/admin/governance-admin/news',
  NEWS_EDIT: '/admin/governance-admin/news/edit',
  NEWS_NEW: '/admin/governance-admin/news/new',
  NEWS_PROMOTION: '/admin/governance-admin/news-promotion',
  NEWS_PROMOTION_EDIT: '/admin/governance-admin/news-promotion/edit',
  NEWS_PROMOTION_NEW: '/admin/governance-admin/news-promotion/new',
} as const;

export const LOGIN_PATHS = {
  ADMIN: '/admin/login',
  MERCHANT: '/login',
} as const;

